import {isUndefined} from "./base";
import {omitBy} from "./omitBy";

export function omitUndefined<T extends object>(object: T): Partial<T> {
  return omitBy<T>(object, (value) => {
    return isUndefined(value);
  });
}
